import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Realized Gain & Loss";
const description = `The Realized Gain & Loss Report captures the actual profit or loss resulting from fluctuations in foreign currency exchange rates between the time a transaction is initiated (e.g., product purchase from a supplier or sale to a customer) and when it is finally settled (paid or received). This profit or loss, often termed an FX (Foreign Exchange) gain or loss, is realized because the cash transaction is complete, with the amount of home currency received or paid being different from the original recorded value due to the change in the exchange rate.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const RealizedGainLoss: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RealizedGainLoss;
